import React from 'react';
import { Grid, MenuItem, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { lowerCase, startCase } from 'lodash';

import ScreenSaveCancelBlock from '@dyl/blocks/ScreenSaveCancelBlock';
import AudioPicker from '@dyl/components/AudioPicker';
import LoadingScreen from '@dyl/components/LoadingScreen';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import withLevel from "@dyl/utils/withLevel";

import useLogic from './logic';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.md,
    },
}));


export default withLevel(RubricEdit);

function RubricEdit({ globalLevel }) {
    const {
        submit,
        isLoading,
        isSaving,

        levelName,
        skillName,
        taskTypeName,

        phase, setPhase, phases,

        text, setText,
        audioId, setAudioId,
    } = useLogic();

    const classes = useStyles();

    const onTextChange = useChangeEvent(setText);
    const onPhaseChange = useChangeEvent(setPhase);

    return (
        <div className={classes.root}>
            <LoadingScreen open={isLoading} />

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label='Language Level'
                        value={levelName}
                        disabled
                        variant='filled'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label='Skill'
                        value={skillName}
                        disabled
                        variant='filled'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label='Task Type'
                        value={taskTypeName}
                        disabled
                        variant='filled'
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        select
                        label='Phase'
                        value={phase}
                        onChange={onPhaseChange}
                        variant='filled'
                        fullWidth
                    >
                        {phases.map(p =>
                            <MenuItem key={p} value={p}> {p === 'N/A' ? p : startCase(lowerCase(p))} </MenuItem>
                        )}

                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label='Rubric Text'
                        helperText='e.g. Listen and choose the correct picture.'
                        value={text ?? ''}
                        onChange={onTextChange}
                        variant='filled'
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={false} sm={6}/>{/* Spacer */}

                <Grid item xs={12} sm={6}>
                    <AudioPicker
                        label='Rubric Audio'
                        helperText='Audio to be played alongside the rubric text.'
                        value={audioId ?? ''}
                        onChange={id => setAudioId(id)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={false} sm={6} />{/* Spacer */}
            </Grid>

            <ScreenSaveCancelBlock
                save={submit}
                cancelTo={`/${globalLevel.label}/rubrics`}
                disabled={isSaving}
                saveDisabled={isLoading}
            />
        </div>
    );
};